/*
 * Copyright (c) 2020. World Wide Generation Ltd
 */

import React from 'react';

const ToolbarDivider = ({ hidden }: { hidden?: boolean }) => {
  if (hidden) {
    return <></>;
  }

  return <div className='d-flex'>
    <div className='action-divider'></div>
  </div>;
}

export default ToolbarDivider;
